import { useApi } from 'services';


export const useSaveQuestionnaireAnswer = (idOperation) => useApi(
    `/v2/operation/${idOperation}/questionnaire-answer`,
    'POST',
    {},
    {}
);

export const useSaveQuestionnaireAnswerSync = (idOperation) => useApi(
    `/v2/operation/${idOperation}/questionnaire-answer`,
    'POST',
    {},
    {},
    true
);

export const useGetQuestionnaireAnswer = (idOperation) => useApi(
    `/v2/operation/${idOperation}/questionnaire-answer`,
    'GET',
    {},
    {}
);

export const useGetQuestionnairesByIdProduct = (idProduct) => useApi(
    `/v2/questionnaire/product/${idProduct}`,
    'GET',
    {},
    {}
);

export const useDeleteQuestionnaireAnswer = (idOperation) => useApi(
    `/v2/operation/${idOperation}/questionnaire-answer`,
    'DELETE',
    {},
    {}
);

export const useCompareQuestionnairesByIdOperationSync = (idOperation) => useApi(
    `/v2/operation/${idOperation}/compare-questionnaire-answer`,
    'GET',
    {},
    {},
    true
);

export const useSaveQuestionsPayments = (idOperation) => useApi(
    `/payments/save-questions-payments/${idOperation}`,
    'POST',
    {},
    {},
    true
);